export const spacing = {
  tiny: '0.25rem',
  small: '0.5rem',
  medium: '1rem',
  large: '2rem',
  xlarge: '4rem',
  xxlarge: '8rem'
}
